import s from "styled-components";
import { Button } from "_c/button";
import { Price } from "_c/modules/profile/common/Service/styled";
export {
  Wrap,
  TitleAndDiscountWrap,
  Title,
  Price,
  PriceUnitDelim,
  Unit,
  Duration,
  Info,
  DescLabel,
  ActiveDiscount,
} from "_c/modules/profile/common/Service/styled";

export const OldPrice = s(Price)`
  opacity: 0.35;
  color: var(--font-color-accent);
  margin-inline-end: 7px;
`;
export const NoMasterContainer = s.div`
`;
export const NoMasterAttention = s.div`
  margin-top: 7px;
  > span:first-child {
    margin-inline-end: 5px;
    font-weight: 500;
    width: 25px;
    height: 25px;
    color: white;
    border-radius: 50%;
    background-color: var(--color-primary);
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  > span:last-child {
    color: var(--font-color-accent);
  }
`;
export const AvgPrice = s.div`
  color: var(--font-color-accent);
  margin-top: 4px;
`;
export const SelectedMaster = s.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 7px;
  align-items: flex-start;
  > strong {
    color: var(--font-color-accent);
  }
  @media(max-width: 550px) {
    align-items: center;
  }
`;
export const MasterName = s.span`
  padding-top: 2px;
  font-weight: 500;
  color: var(--font-color-emp);
  margin-inline-start: 8px;
`;
export const AvatarAndName = s.div`
  display: flex;
  margin-top: 5px;
`;

export const BasketButton = s(Button)`
  display: inline-flex;
  margin-top: 10px;
  align-items: center;
`;
export const InBasketWrap = s.div`
  margin-top: 10px;
  color: var(--color-cta);
`;
export const InBasketBadge = s.span`
  margin-inline-end: 5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: var(--color-cta);
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
